// src/components/about-main.js

import React from 'react';
import { FaCube, FaChartArea, FaGlobe } from 'react-icons/fa6';
import './about-main.css'; 

const AboutMain = () => {
    return (
        <section className="about-hero-matrix-flow">
            
            {/* 1. Deep Illusion Background Element (The Pulsing Core) */}
            <div className="matrix-core-glow"></div>
            
            {/* 2. Flow Overlay Mesh (Animated Mesh for Data Movement) */}
            <div className="flow-overlay-mesh"></div>

            <div className="container hero-matrix-container">
                
                <div className="hero-content-matrix">
                    
                    <h1 className="hero-title-matrix">
                        The <span className="matrix-text-outline">Digital Core</span> of Indian <span className="accent-green-matrix">Financing.</span>
                    </h1>
                    <p className="hero-tagline-matrix">
  <strong>Singh Finlease</strong> integrates advanced data modeling with ethical practices, providing a high-speed, secure, and transparent lending experience. 
  <br />
  GST No: <strong>: 07AABCS8396R1ZB</strong>
</p>
                    
                    {/* Key Feature Tiles - Layered 3D Look (Information unchanged as it describes capability) */}
                    <div className="key-feature-tiles-matrix">
                        <div className="feature-tile-matrix tile-1">
                            <FaCube className="feature-icon-matrix icon-green-matrix" />
                            <h4>Robust <span className="accent-magenta-matrix">Framework</span></h4>
                        </div>
                        <div className="feature-tile-matrix tile-2">
                            <FaChartArea className="feature-icon-matrix icon-magenta-matrix" />
                            <h4>Data-Driven <span className="accent-green-matrix">Insights</span></h4>
                        </div>
                        <div className="feature-tile-matrix tile-3">
                            <FaGlobe className="feature-icon-matrix icon-green-matrix" />
                            <h4>Nationwide <span className="accent-magenta-matrix">Reach</span></h4>
                        </div>
                    </div>
                </div>

                {/* Vertical Stat Strip with Shadowing (REVISED CONTENT HERE) */}
                <div className="hero-stats-matrix">
                    <div className="stat-item-matrix">
                        <p className="stat-label-matrix">Processing Time</p>
                        <h3 className="stat-value-matrix accent-green-matrix">0.5 Sec</h3>
                    </div>
                    <div className="stat-separator"></div>
                    <div className="stat-item-matrix">
                        <p className="stat-label-matrix">Industry Trust</p>
                        <h3 className="stat-value-matrix accent-magenta-matrix">99.9%</h3>
                    </div>
                    <div className="stat-separator"></div>
                    <div className="stat-item-matrix">
                        <p className="stat-label-matrix">Platform Stability</p>
                        <h3 className="stat-value-matrix accent-green-matrix">24/7</h3>
                    </div>
                </div>
            </div>
            
            {/* Architectural Separator */}
            <div className="section-divider-matrix-bottom"></div> 
        </section>
    );
};

export default AboutMain;